import { create } from 'zustand';

import type { CurrentUser } from '@/types/api';

interface AuthState {
  user: CurrentUser | null;
  isInitialising: boolean;
  setUser: (user: CurrentUser | null) => void;
  setInitialised: () => void;
  clear: () => void;
  can: (permission: string) => boolean;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  user: null,
  isInitialising: true,

  setUser: (user) => set({ user, isInitialising: false }),
  setInitialised: () => set({ isInitialising: false }),
  clear: () => set({ user: null, isInitialising: false }),

  can: (permission) => {
    const { user } = get();
    if (!user) return false;

    const granted = user.permissions;
    if (granted.includes('*:*') || granted.includes(permission)) return true;

    const [resource] = permission.split(':');
    return granted.includes(`${resource}:*`);
  },
}));
